import React from 'react';
import './Navbar.css';
import { Link } from 'react-router-dom';

const Navbar = () => {
    return (
        <div className="Navbar">
            <nav className="navbar navbar-fixed-top navbar-expand-lg navbar-dark ">
                <div className="container">
                    <Link to="/" className="navbar-brand">
                        {/* <h3>&lt; Noor Muhammad &gt;</h3> */}
                        <h3>Noor Muhammad</h3>
                    </Link>
                    <Link to="#" className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <i className="fas fa-bars"></i>
                    </Link>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav ml-auto align-items-center">
                        <li className="nav-item">
                            <Link className="nav-link mr-4" to="/"><span>HOME</span></Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link mr-4" to="/about"><span>ABOUT</span></Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link mr-4" to="/projects"><span>PROJECTS</span></Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link mr-4" to="/blogs"><span>BLOGS</span></Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link mr-4" to="/contact"><span>CONTACT</span></Link>
                        </li>
                        <li>
                        <a className="btn" href="https://drive.google.com/u/0/uc?id=1y-BFjh9YqQ0odZy4z_6YYnAvVB2M_eLS&export=download" target="_blank" rel="noopener noreferrer">RESUME</a>
                        </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </div>
    );
};

export default Navbar;